import React from 'react'
import {AggregateFunctionType} from "./types";
import FieldProto from "../../fields3/proto/field-proto";
import {Aggregator} from "./aggregator";

export class AggregatorSum extends Aggregator {

    // public value : number

    constructor(field: FieldProto) {

        super(AggregateFunctionType.SUM, field)

        // this.value = 0
    }


    public processItem(model:any):void {

        // const value = this.field.getAggregationValue(.....)
        this.value += model[this.field.fieldId]

    }

    public render() {

        return (
            <div className="ui5-aggregator-value">
                S{this.value}
            </div>
        )

    }
}